/* Nina — Clarendale-style storefront behaviour */
(function () {
  'use strict';

  function initShip(root) {
    root.querySelectorAll('[data-cl-ship]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-days') || '0', 10);
      var d = new Date();
      d.setDate(d.getDate() + days);
      var out = el.querySelector('[data-cl-ship-date]');
      if (out) {
        out.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'long', day: 'numeric' });
      }
    });
  }

  function initProof(root) {
    root.querySelectorAll('[data-cl-proof]').forEach(function (el) {
      if (el._clInit) return;
      el._clInit = true;
      var items = el.querySelectorAll('.cl-proof__item');
      if (items.length < 2) return;
      var i = 0;
      var ms = parseInt(el.getAttribute('data-interval') || '4000', 10);
      setInterval(function () {
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, ms);
    });
  }

  function initSlider(root) {
    root.querySelectorAll('[data-cl-slider]').forEach(function (el) {
      if (el._clInit) return;
      el._clInit = true;
      var track = el.querySelector('[data-cl-slider-track]');
      if (!track) return;
      var slides = track.children;
      var fill = el.querySelector('[data-cl-slider-fill]');
      var n = slides.length;
      var i = 0;
      function go(k) {
        i = (k + n) % n;
        track.style.transform = 'translateX(' + (-100 * i) + '%)';
        if (fill) fill.style.width = ((i + 1) / n * 100) + '%';
      }

      // Autoplay: advance to the next slide automatically, like Clarendale's
      // review carousel. Pauses on hover/touch/manual navigation and while
      // the tab is hidden, then resumes a moment later.
      var autoplayMs = parseInt(el.getAttribute('data-autoplay') || '5000', 10);
      var autoplayEnabled = el.getAttribute('data-autoplay') !== 'false' && n > 1;
      var timer = null;
      function stopAutoplay() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function startAutoplay() {
        if (!autoplayEnabled) return;
        stopAutoplay();
        timer = setInterval(function () { go(i + 1); }, autoplayMs);
      }
      function restartAutoplay() { stopAutoplay(); startAutoplay(); }

      var prev = el.querySelector('[data-cl-slider-prev]');
      var next = el.querySelector('[data-cl-slider-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); restartAutoplay(); });
      if (next) next.addEventListener('click', function () { go(i + 1); restartAutoplay(); });

      var x0 = null;
      track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stopAutoplay(); }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (x0 === null) { startAutoplay(); return; }
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
        x0 = null;
        startAutoplay();
      });

      el.addEventListener('mouseenter', stopAutoplay);
      el.addEventListener('mouseleave', startAutoplay);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAutoplay(); else startAutoplay();
      });

      go(0);
      startAutoplay();
    });
  }

  // Small deterministic PRNG (mulberry32) seeded from a string, so the
  // "popular size" + "only N left" numbers are stable for a given product
  // across page loads/refreshes, instead of re-randomizing every time.
  function hashSeed(str) {
    var h = 5381;
    for (var i = 0; i < str.length; i++) {
      h = ((h << 5) + h + str.charCodeAt(i)) | 0;
    }
    return h >>> 0;
  }
  function mulberry32(seed) {
    return function () {
      seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function initStockUrgency(root) {
    var sizeWraps = root.querySelectorAll('.variant-input-wrap[data-handle="size"]');
    sizeWraps.forEach(function (sizeWrap) {
      if (sizeWrap._clStockInit) return;
      sizeWrap._clStockInit = true;

      var options = Array.prototype.slice.call(sizeWrap.querySelectorAll('.variant-input')).map(function (vi) {
        return { input: vi.querySelector('input[data-variant-input]'), label: vi.querySelector('label.variant__button-label') };
      }).filter(function (o) {
        return o.input && o.label && !o.input.classList.contains('disabled');
      });
      if (!options.length) return;

      var productRoot = sizeWrap.closest('[data-product-id]');
      var productId = productRoot ? productRoot.getAttribute('data-product-id') : 'p';
      var rand = mulberry32(hashSeed(productId + '-stock-urgency'));

      var popCount = options.length > 4 ? 2 : 1;
      var chosen = [];
      // Almost always flag the first size as popular/low-stock — it's the
      // size shoppers see first, so it creates the most urgency. Seeded so
      // it stays the same size on every visit to this product.
      if (rand() < 0.92) {
        chosen.push(options[0]);
      }
      if (chosen.length < popCount) {
        var pool = options.slice(1).filter(function (o) { return chosen.indexOf(o) === -1; });
        while (chosen.length < popCount && pool.length) {
          chosen.push(pool.splice(Math.floor(rand() * pool.length), 1)[0]);
        }
      }

      var stockBySize = {};
      chosen.forEach(function (o) {
        o.label.setAttribute('data-cl-level', 'low');
        var dot = document.createElement('span');
        dot.className = 'cl-dot-pulse';
        dot.setAttribute('aria-hidden', 'true');
        o.label.appendChild(dot);
        stockBySize[o.input.value] = 2 + Math.floor(rand() * 3); // 2, 3 or 4 — stable per product
      });

      var wrapper = sizeWrap.closest('.variant-wrapper') || sizeWrap.parentElement;
      var stockLine = wrapper.parentElement.querySelector(':scope > .cl-stock-urgency');
      if (!stockLine) {
        stockLine = document.createElement('p');
        stockLine.className = 'cl-stock-urgency';
        wrapper.insertAdjacentElement('afterend', stockLine);
      }

      var form = sizeWrap.closest('form') || root;
      var colorWrap = form.querySelector('.variant-input-wrap[data-handle="color"]');

      function render() {
        var checked = sizeWrap.querySelector('input:checked');
        var sizeVal = checked ? checked.value : null;
        var n = sizeVal ? stockBySize[sizeVal] : null;
        if (n) {
          var colorChecked = colorWrap ? colorWrap.querySelector('input:checked') : null;
          var colorVal = colorChecked ? colorChecked.value : null;
          stockLine.innerHTML = 'Only <b>' + n + ' left</b>' + (colorVal ? ' in ' + colorVal + ', size ' + sizeVal : ', size ' + sizeVal);
          stockLine.hidden = false;
        } else {
          stockLine.hidden = true;
        }
      }

      render();
      sizeWrap.addEventListener('change', render);
      if (colorWrap) colorWrap.addEventListener('change', render);
    });
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-cl-satc]');
    if (!bar || bar._clInit) return;
    bar._clInit = true;
    document.body.appendChild(bar);

    var section = document.querySelector('[data-section-type="product"]');
    var mainBtn = section && section.querySelector('[data-product-blocks] [data-add-to-cart]');
    if (!mainBtn) return;
    var btn = bar.querySelector('[data-cl-satc-btn]');
    var priceEl = bar.querySelector('[data-cl-satc-price]');
    var cmpEl = bar.querySelector('[data-cl-satc-compare]');
    var srcPrice = section.querySelector('[data-product-price]');
    var srcCmp = section.querySelector('[data-compare-price]');
    var srcWrap = section.querySelector('[data-product-price-wrap]');

    function sync() {
      if (srcPrice && priceEl) priceEl.textContent = srcPrice.textContent.trim();
      if (cmpEl) {
        var showCmp = srcCmp && srcWrap && !srcWrap.classList.contains('hide') && srcCmp.textContent.trim() !== '';
        cmpEl.textContent = showCmp ? srcCmp.textContent.trim() : '';
      }
      btn.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('[data-add-to-cart-text]');
      if (label) btn.textContent = label.textContent.trim();
    }
    sync();
    var mo = new MutationObserver(sync);
    [srcPrice, srcCmp, srcWrap, mainBtn].forEach(function (n) {
      if (n) mo.observe(n, { childList: true, subtree: true, characterData: true, attributes: true });
    });

    btn.addEventListener('click', function () {
      mainBtn.click();
      setTimeout(updateLadder, 1500);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        btn.tabIndex = past ? 0 : -1;
        document.body.classList.toggle('cl-satc-open', past);
      }).observe(mainBtn);
    }

    var qtys = (bar.getAttribute('data-qtys') || '').split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return n > 0; });
    var discounts = (bar.getAttribute('data-discounts') || '').split(',').map(function (s) { return s.trim(); });
    var msg = bar.querySelector('[data-cl-satc-msg]');
    var fill = bar.querySelector('[data-cl-satc-fill]');

    function renderLadder(count) {
      if (!msg || !qtys.length) return;
      var max = qtys[qtys.length - 1];
      var next = -1;
      for (var k = 0; k < qtys.length; k++) { if (count < qtys[k]) { next = k; break; } }
      if (next === -1) {
        msg.innerHTML = 'You unlocked <b>' + (discounts[qtys.length - 1] || '') + '</b> off';
      } else {
        var need = qtys[next] - count;
        msg.innerHTML = 'Add <b>' + need + ' ' + (need === 1 ? 'item' : 'items') + '</b> and save <b>' + (discounts[next] || '') + '</b>';
      }
      if (fill) fill.style.width = Math.min(100, count / max * 100) + '%';
    }

    function updateLadder() {
      fetch((window.theme && theme.routes && theme.routes.cart) || '/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { renderLadder(c.item_count || 0); })
        .catch(function () { renderLadder(0); });
    }
    renderLadder(0);
    updateLadder();
    ['ajaxProduct:added', 'cart:updated', 'cart:open'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(updateLadder, 400); });
    });
  }

  function init(root) {
    root = root || document;
    initShip(root);
    initProof(root);
    initSlider(root);
    initStockUrgency(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    document.querySelectorAll('body > [data-cl-satc]').forEach(function (b) { b.remove(); });
    init(e.target);
    init(document);
  });
})();
